import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import DivHonorPanel from './components/DivHonorPanel';

import {getLanguage} from '../../util/localStorage';
import {FORM_HONOR_PLAIN, } from '../../util/consts/forms';
import {CLASS_HONOR, } from '../../util/consts/classes';

class HonorPlainPage extends PlainPage {
	
	constructor(props) {
		super(props);
		this.formPath = FORM_HONOR_PLAIN;
		this.formTitle = 'Нагорода';
		this.buildInstanceCard = this.buildHonorCard;
	}
	componentDidMount = async () => {
		this.init(CLASS_HONOR)
		document.title = 'BOM. ' + this.formTitle;
	}
	
	buildHonorCard = (honorInstance) => {
		let card = '';

		if(honorInstance.rootField.value.honorInfo.value.length > 0) {
			let currentLanguage = getLanguage();
			let info = null;
			for(let inf of honorInstance.rootField.value.honorInfo.value) {
				if( inf.value.language.value == currentLanguage && inf.value.name.value ) {
					info = inf;
					break;
				}
			}
			if( info == null ) {
				for(let inf of honorInstance.rootField.value.honorInfo.value) {
					if( inf.value.name.value ) {
						info = inf;
						break;
					}
				}
			}			
			if( info )
				card = info.value.name.value
		}
		
		if( ! card ) {
			for(let f of honorInstance.rootField.value.images.value) {
				if( f.value.resourceName.value ) {
					card = f.value.resourceName.value;
					break;
				}
			}
		}
		
		return card;
	}
	
	renderBody() {
		let instance = this.state.instance;
		let readOnly = this.instanceReadOnly;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<DivHonorPanel plain={this} instance={instance} isPlain={true} readOnly={readOnly} />
				</div>
			</div>
		)
	}
}

export default HonorPlainPage;
